<template>
    <v-dialog max-width="450" persistent v-model="dialog">
        <v-card>
            <v-card-title class="headline">Update Application Details</v-card-title>
            <v-card-text>
                <ValidationObserver ref="observer" v-slot="{failedRules, failed ,passes}">
                    <form>
                        <ValidationProvider vid="applicationNumber" name="applicationNumber"
                                             :rules="{numeric:true, max:10 }" ref="observerEditApplicationNumber"
                                            v-slot="{errors, failedRules}">
                            <v-text-field
                                    :error-messages="$translatedErrorMessages(failedRules,'applicationNumber')"
                                    label="Application Number"
                                    v-model="application.applicationNumber">
                            </v-text-field>
                        </ValidationProvider>

                        <ValidationProvider rules="required" v-slot="{errors, failedRules}">
                            <v-select
                                    :error-messages="$translatedErrorMessages(failedRules,'customerApplicationStatus')"
                                    :items="$parent.filters.applicationStatus"
                                    item-text="text"
                                    item-value="value"
                                    label="Application Status"
                                    v-model="application.applicationStatus"
                            >
                            </v-select>
                        </ValidationProvider>

                        <div v-if="application.applicationStatus === 'A'">
                            <ValidationProvider
                                    :rules="{numeric:true, required: true, min_value: validation.minAmount, max_value: validation.maxAmount }"
                                    v-slot="{errors, failedRules}">
                                <v-text-field
                                        :error-messages="$translatedErrorMessages(failedRules,'financingAmountApproved', [validation.minAmount, validation.maxAmount])"
                                        label="Financing Amount Approved"
                                        prefix="RM"
                                        required
                                        v-model="application.financingAmountApproved">
                                </v-text-field>
                            </ValidationProvider>
                            <ValidationProvider
                                    :rules="{numeric:true, required: true, min_value: validation.minTenure, max_value: validation.maxTenure  }"
                                    v-slot="{errors, failedRules}">
                                <v-text-field
                                        :error-messages="$translatedErrorMessages(failedRules,'tenureApproved', [validation.minTenure, validation.maxTenure])"
                                        label="Tenure Approved"
                                        required
                                        suffix="Months"
                                        v-model="application.tenureApproved">
                                </v-text-field>
                            </ValidationProvider>
                        </div>

                        <ValidationProvider :rules="{required: false, min : 5, max : 10, regex:/^[a-zA-Z0-9\s-+#@']+$/ }"
                                            v-slot="{errors, failedRules}">
                            <v-text-field :error-messages="$translatedErrorMessages(failedRules,'internalRating')"
                                          label="Internal Credit Rating" v-model="application.internalRating"></v-text-field>
                        </ValidationProvider>

                        <v-select :error-messages="$translatedErrorMessages(failedRules,'ctosRatingAvailable')"
                                  :items="ctosRatingAvailableItems"
                                  item-text="text"
                                  item-value="value"
                                  label="CTOS Score Available"
                                  v-model="application.ctosRatingAvailable"
                        ></v-select>

                        <div v-if="application.ctosRatingAvailable && application.ctosRatingAvailable === 'Y' ">
                            <ValidationProvider :rules="{required: true, numeric: true, min_value:300, max_value:850}"
                                                v-slot="{errors, failedRules}">
                                <v-text-field :error-messages="$translatedErrorMessages(failedRules,'ctosRating')"
                                              class="requiredSticker"
                                              label="CTOS Score"
                                              v-model="application.ctosRating">
                                </v-text-field>
                            </ValidationProvider>
                        </div>

                        <ValidationProvider :rules="{required: false}" v-slot="{errors, failedRules}">
                            <v-select :error-messages="$translatedErrorMessages(failedRules,'ccrisRatingAvailable')"
                                      :items="ccrisRatingAvailableItems"
                                      item-text="text"
                                      item-value="value"
                                      label="CCRIS Score Available"
                                      v-model="application.ccrisRatingAvailable"
                            ></v-select>
                        </ValidationProvider>

                        <div v-if="application.ccrisRatingAvailable && application.ccrisRatingAvailable === 'Y' ">
                            <ValidationProvider :rules="{required: true, numeric: true, min_value:0, max_value:999}"
                                                v-slot="{errors, failedRules}">
                                <v-text-field :error-messages="$translatedErrorMessages(failedRules,'ccrisRating')"
                                              class="requiredSticker"
                                              label="CCRIS Score"
                                              v-model="application.ccrisRating">
                                </v-text-field>
                            </ValidationProvider>
                        </div>

                    </form>
                    <div>
                        <div v-show="serverError">
                            <p style="color:red" >Something went wrong. Please try again later</p>
                        </div>
                    </div>
                    <v-card-actions align="right">
                        <v-spacer></v-spacer>
                        <v-skeleton-loader class="mr-3" :loading="loader" transition="scale-transition" type="button">
                            <v-btn @click="dialog=false" color="primary">Cancel</v-btn>
                        </v-skeleton-loader>
                        <v-skeleton-loader :loading="loader" transition="scale-transition" type="button">
                            <v-btn @click="passes(updateApplicationStatus)" color="primary" dark>
                                Save
                            </v-btn>
                        </v-skeleton-loader>
                    </v-card-actions>
                </ValidationObserver>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
    import {ValidationObserver, ValidationProvider} from 'vee-validate';
    import {dataServices} from "@/services";


    export default {
        components: {
            ValidationObserver, ValidationProvider
        },
        data() {
            return {
                dialog: false,
                application: {},
                loader: false,
                validation: {
                    minAmount: 20000,
                    maxAmount: 5000000,
                    minTenure: 12,
                    maxTenure: 240
                },
                internalRatingAvailableItems: [
                    {text: 'Yes', value: 'Y'},
                    {text: 'No', value: 'N'}
                ],
                ctosRatingAvailableItems: [
                    {text: 'Yes', value: 'Y'}, {
                        text: 'No', value: 'N'}
                ],
                ccrisRatingAvailableItems: [
                    {text: 'Yes', value: 'Y'},
                    {text: 'No', value: 'N'}
                ],
                serverError: false
            }
        },
        methods: {
            init() {
                this.application = Object.assign({}, this.$parent.selectedApplication)
                this.dialog = true
                let productValidation = this.$parent.filters.scheme.filter(f => f.code === this.application.productApplied)[0].validation
                if(productValidation)
                   this.validation=productValidation
            }, updateApplicationStatus() {
                this.loader = true
                dataServices.editApplicationStatus(this.application).then((response) => {
                    this.loader = false
                    if (response.successful) {
                        this.$parent.renderMessage('Successfully updated the application details')
                        this.dialog = false
                        this.loader = false
                    } else {
                        response.errorList.forEach(e => {
                            if(e.field==='applicationNumber' && e.rule==='duplicate'){
                                this.$refs.observerEditApplicationNumber.applyResult({
                                    errors: ['error'],
                                    failedRules: ['duplicate']
                                });
                            }
                        })
                    }
                }).catch((error) => {
                    this.loader = false
                    this.serverError = true
                    console.log('Error' + error)
                })
            }
        }
    }
</script>
